import LogoImg from '@/assets/images/logo.png';
import { ConfigType } from '@/types/configType';
import React, { ChangeEvent, useMemo, useCallback, Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { uniqueId } from 'lodash-es';

interface SelectBoxProps {
  data: ConfigType[];
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  defaultUrl: string;
}

function SelectBox({ data, name, defaultUrl, setName }: SelectBoxProps) {
  const navigate = useNavigate();

  const isShopSwagger = useMemo(() => defaultUrl === 'https://docs.shopby.co.kr/', [defaultUrl]);
  const isServerSwagger = useMemo(() => defaultUrl === 'https://server-docs.shopby.co.kr/', [defaultUrl]);

  const onChangeSelectBox = useCallback(
    ({ target }: ChangeEvent<HTMLSelectElement>) => {
      const { value } = target;
      setName(value);
      window.scrollTo(0, 0);
      navigate(`/?url.primaryName=${value}/`);
    },
    [setName],
  );

  return (
    <div className={`outlinks ${isServerSwagger ? 'outlinks--server' : ''} ${isShopSwagger ? 'outlinks--shop' : ''}`}>
      <a className={'outlinks__logo'} href="https://www.nhn-commerce.com/" target={'_blank'}>
        <img src={LogoImg} alt="nhn commerce - nhn commerce 홈으로 가기" />
      </a>
      <div className={'outlinks__api'}>
        <a className={`api-link ${isShopSwagger ? 'is-active' : ''}`} href="https://docs.shopby.co.kr/">
          샵바이 shop API <span className="ico ico--arrow"></span>
        </a>
        <a className={`api-link ${isServerSwagger ? 'is-active' : ''}`} href="https://server-docs.shopby.co.kr/">
          샵바이 server API<span className="ico ico--arrow"></span>
        </a>
        <a className="api-link api-link--out-link" href="https://workspace.nhn-commerce.com/apiUpdate" target="_blank">
          API <span className="api-link__kor">업데이트</span>
          <span className="ico ico--badge"></span>
          <span className="ico ico--out-link"></span>
        </a>
        <a className="api-link api-link--out-link" href="https://workspace.nhn-commerce.com" target="_blank">
          <span className="api-link__kor" style={{ marginInlineStart: 0 }}>
            워크스페이스 바로가기
          </span>
          <span className="ico ico--out-link"></span>
        </a>
      </div>
      {isShopSwagger && (
        <div className="trigger">
          <a
            className="trigger__link"
            href="https://nhnent.dooray.com/share/pages/WoOk8q6KT1K3MZcLSuyZsw/3520338751321947577"
            target="_blank"
            rel="noopener noreferrer"
          >
            API 호출 가이드를 확인해보세요
          </a>
        </div>
      )}
      <select onChange={onChangeSelectBox} value={name}>
        {data &&
          data.map(({ name }) => (
            <option key={uniqueId('select-box-option')} value={name}>
              {name}
            </option>
          ))}
      </select>
    </div>
  );
}

export default React.memo(SelectBox);
